/* eslint-disable import/no-unused-modules */
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import * as ReactDOM from 'react-dom';
import * as React from 'react';
import { initCustomComponent } from '@narvar/cth';
import App from './components/App';
import CustomComponentContext from './components/CustomComponentContext';
import Providers from './components/Providers';

async function startBugsnag() {
  let customComponent;
  try {
    customComponent = await initCustomComponent();
    return customComponent;
  } finally {
    // start bugsnag even if initCustomComponent fails
    Bugsnag.start({
      apiKey: 'a13be75cec72780791f71f8050493fcf', // britney
      plugins: [new BugsnagPluginReact()],
      collectUserIp: false, // gdpr compliance
      appVersion: process.env.VERSION,
      releaseStage: process.env.BUGSNAG_RELEASE_STAGE,
      enabledReleaseStages: ['qa', 'staging', 'production'],
      metadata: {
        retailerMoniker: customComponent?.state.pageContext.retailerMoniker,
        trackingNumbers: customComponent?.state.pageContext.trackingNumbers,
      },
    });
  }
}

(async () => {
  const customComponent = await startBugsnag();

  const ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React);
  if (!ErrorBoundary) throw new Error('Could not create ErrorBoundry');

  ReactDOM.render(
    <ErrorBoundary>
      <CustomComponentContext.Provider value={customComponent}>
        <Providers>
          <App />
        </Providers>
      </CustomComponentContext.Provider>
    </ErrorBoundary>,
    document.querySelector('#app'),
  );
})().catch((err) => {
  Bugsnag.notify(err instanceof Error ? err : JSON.stringify(err));
});
